import { Typography } from '@mui/material'
import { Box } from '@mui/system'

import { styles } from './SubPageHeader.styles'

export interface Props {
	backgroundGradient: string
	subtitle: string
	title: string
}

function SubPageHeader({ backgroundGradient, title, subtitle }: Props) {
	return (
		<Box
			sx={{ ...styles.container, background: backgroundGradient }}
			data-testid="sub-page-header"
		>
			<Typography sx={styles.title} data-testid="sub-page-header__title">
				{title}
			</Typography>
			<Typography
				sx={styles.subtitle}
				data-testid="sub-page-header__subtitle"
			>
				{subtitle}
			</Typography>
		</Box>
	)
}

export default SubPageHeader
